import React, { useState } from 'react'
import PageHeader from '../../components/Typography/PageHeader'
import PlotList from './components/plot/PlotList'
import { useAuth } from '../../applications/hooks/UseAuth'
import { Form, useNavigate } from 'react-router-dom'
import { makeStyles } from '@mui/styles'

import { Toolbar as MuiToolbar } from '@mui/material'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import PlotView from './components/plot/PlotView'
import PlotInPLantingService from './services/plotInPlanting'
import ProvinceFilter from '../provinces/components/ProvinceFilter'

const CURRENT_PAGE = 'agroforestry_plantation'

const useStyles = makeStyles((theme) => ({
    siteChange: {
        '& .MuiBottomNavigation-root': {
            height: '50px',
            borderRadius: 10,
            borderColor: '#0FCB8F',
            borderWidth: 2,
            background: '#43D5A7'
        },
        '& .MuiBottomNavigationAction-root': {
            background: '#0FCB8F',
            minWidth: '18vw'
        },
        '& .MuiBottomNavigationAction-root.Mui-selected': {
            borderRadius: 10,
            background: 'none'
        },
        '& .MuiBottomNavigationAction-label': {
            fontSize: 15,
            color: '#FFFFFF'
        },
        '& .MuiBottomNavigationAction-root.Mui-selected .MuiBottomNavigationAction-label': {
            fontSize: 15,
            color: '#FFFFFF'
        }
    }
}))

function PlotPLanting() {
    const classes = useStyles()
    const navigate = useNavigate()

    const { haveAccessTo } = useAuth()
    const service = PlotInPLantingService.load()
    const [needLoad, setNeedLoad] = useState(true)
    const [filter, setFilter] = useState({})
    const useDrawer = true

    const [value, setValue] = useState('plots')

    const handleChange = (event, newValue) => {
        setValue(newValue)
        navigate('/app/agroforestry/plantations/' + newValue)
    }

    return (
        <div className={'card w-full bg-base-100 font-sans font-bold'} style={{ paddingBottom: 20 }}>
            <PageHeader title={'Suivi des parcelles'} subTitle={'Gestions parcelles'} />
            <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                <ProvinceFilter setNeedLoad={setNeedLoad} filter={filter} setFilter={setFilter} />
                <MuiToolbar style={{ padding: 0, alignItems: 'start' }} className={classes.siteChange}>
                    <BottomNavigation showLabels value={value} onChange={handleChange}>
                        <BottomNavigationAction key="1" label="Plantations" value="" />
                        <BottomNavigationAction key="2" label="Paysans partenaires" value="peasants" />
                        <BottomNavigationAction key="3" label="Suivi des parcelles" value="plots" />
                    </BottomNavigation>
                </MuiToolbar>
            </div>
            <PlotList
                isPlotMonitoring={true}
                service={service}
                setNeedLoad={setNeedLoad}
                haveAccessTo={haveAccessTo}
                needLoad={needLoad}
                filterFromList={filter}
                Form={PlotView}
                drawer={useDrawer}
                currentPage={CURRENT_PAGE}
            />
        </div>
    )
}

export default PlotPLanting
